import {Box, Paragraph, Text} from 'grommet'
import {ReactNode} from 'react'

interface Props {
  text: string | ReactNode
  icon?: ReactNode
  secondaryText?: string | ReactNode
  textColor?: string
}

export default function StatusInfo({
  text,
  icon,
  secondaryText,
  textColor,
}: Props) {
  return (
    <Box align="center">
      <Paragraph textAlign="center" color={textColor}>
        <Text size="large" weight="bold">
          {text}
        </Text>
      </Paragraph>

      {icon && <Paragraph margin="xsmall">{icon}</Paragraph>}

      {secondaryText && (
        <Paragraph size="large" textAlign="center">
          {secondaryText}
        </Paragraph>
      )}
    </Box>
  )
}
